import { Link } from "gatsby"
import React, { useEffect, useState } from "react"
import cookie from '../../images/cookie.png'
// import { truncate } from "fs"



const CookieBanner = ({ data }) => {
  const [isCookieAccepted, setIsCookieAccepted] = useState(false)
  const [isCookieDeclined, setIsCookieDeclined] = useState(false)

  useEffect(() => {
    // check if cookie is set
    const cookieAccepted = (name) => {
      var re = new RegExp(`${name}=([^;]+)`)
      var value = re.exec(document.cookie)
      return value != null ? unescape(value[1]) : null
    }

    // runs cookieAccepted and removes cookie banner if cookie is set, and if not set adds a cookie banner
    if (cookieAccepted('gatsby-gdpr-facebook-pixel', 'gatsby-gdpr-google-analytics') && isCookieAccepted !== true) {
      setIsCookieAccepted(true)
    } else if(cookieAccepted('cookieDeclined')) {
      setIsCookieDeclined(true)
    }
  })

  // Sets cookie onclick and fires GTM
  const setCookie = (googleA, facebookP) => {
    // Setting Cookie
    let d = new Date()
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000)
    const expires = `expires=${d.toUTCString()}`
    document.cookie = `${googleA}=${true};${expires};path=/`
    if(facebookP) {
      document.cookie = `${facebookP}=${true};${expires};path=/`
    }


    // Remove Cookie Banner
    setIsCookieAccepted(true)
    
  }

  // Set cookie banner
  let cookieBannerHtml = null

  if (!isCookieAccepted && !isCookieDeclined) {
    cookieBannerHtml = (
        <div id="cookie-banner">
            <img className="cookie-image" src={cookie} alt="cookie" />
            <p className="p-cookie text-center space-xs-up">
            <b>Vi indsamler cookies</b>
            <br />
              Det gør vi for at forstå, hvordan vores side bliver brugt, og hvem der bruger den. Det er med til at give dig den bedste brugeroplevelse.
            <br />
              <a href="http://www.fairtrade-maerket.dk/Privacy-Policy" target="_blank">Se cookiepolitik</a>
            </p>
            <button className="btn btn-cookies" onClick={() => setCookie('gatsby-gdpr-facebook-pixel', 'gatsby-gdpr-google-analytics')}>
              Det er i orden!
            </button>
            <button className="btn btn-decline btn-secondary" onClick={() => setCookie('cookieDeclined')}>
              Nej tak
            </button>
        </div>
    )
  } 

  return cookieBannerHtml
}

export default CookieBanner

